export enum MultivariateBasisType {
    NotSpecified = 0,
    Load = 1,
    Impression = 2
}
